import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { removeCartLineWithResult as removeCartLineApi } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, RemoveCartLine } from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { dispatchDeleteProduct } from "@store/Services/AnalyticsService";

replaceInChain(chain, RemoveCartLine, async props => {
    const result = await removeCartLineApi(props.apiParameter); // Poolcorp Custom Code
    
    /* Poolcorp Custom Code */
    const state = props.getState();
    const cart = getCurrentCartState(state).value;

    const cartLine = cart?.cartLines?.filter(cartLine => {
        return cartLine.id === props.parameter.cartLineId;
    });

    if (cartLine) {
        dispatchDeleteProduct(cartLine as CartLineModel[]);
    }
    /* Poolcorp Custom Code */
});
